import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(Backend) // Завантаження перекладів із файлів у public/locale
  .use(LanguageDetector) // Автоматичне визначення мови (розкоментуйте його)
  .use(initReactI18next) // Ініціалізація для React
  .init({
    fallbackLng: "en", // Мова за замовчуванням
    // debug: true, // Розкоментуйте для дебагу, якщо потрібно
    ns: ["translation"], // Простір імен для перекладів
    defaultNS: "translation", // За замовчуванням використовуємо "translation"

    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json", // Шлях до файлів перекладів
    },

    detection: {
      order: ["localStorage", "cookie", "navigator", "htmlTag"], // Порядок визначення мови
      caches: ["localStorage"], // Зберігати вибір користувача в localStorage
    },

    interpolation: {
      escapeValue: false, // React уже захищає від XSS
    },
  });

export default i18n;
